export const SIGN_DISPLAY_TEXT: Record<string, string> = {
  // ── Oncologia ────────────────────────────────────────────────────────
  Câncer:           "Tenho / estou com câncer",
  Quimioterapia:    "Estou fazendo quimioterapia",
  Tumor:            "Tenho um tumor",
  Radioterapia:     "Estou fazendo radioterapia",

  // ── Ortopedia ────────────────────────────────────────────────────────
  Gesso:            "Estou com gesso / tive fratura",
  Fratura:          "Tenho uma fratura",
  Coluna:           "Dor na coluna / problema de coluna",
  Joelho:           "Dor no joelho",
  Ombro:            "Dor no ombro",
  Tornozelo:        "Dor no tornozelo",
  Quadril:          "Dor no quadril",
  Mão:              "Dor na mão / problema na mão",
  Pé:               "Dor no pé",
  Coxa:             "Dor na coxa",

  // ── Saúde Sexual / Obstetrícia ───────────────────────────────────────
  Grávida:          "Estou grávida",
  Gravidez:         "Tenho uma gravidez",
  Bebê:             "É sobre meu bebê / estou esperando bebê",
  Parto:            "Estou em trabalho de parto",
  Menstruação:      "Tenho problema com menstruação",
  Preservativo:     "Uso preservativo / preciso de preservativo",
  Aborto:           "Tive um aborto",
  Gestante:         "Sou gestante",
  Amamentar:        "Estou amamentando / tenho problema para amamentar",

  // ── Saúde Mental / Neurologia ────────────────────────────────────────
  Epilepsia:        "Tenho epilepsia / tive convulsão",
  Deprimido:        "Estou deprimido / com depressão",
  Psiquiatra:       "Preciso de psiquiatra",
  Neurologia:       "Tenho problema neurológico",
  Alzheimer:        "Tenho Alzheimer / demência",
  Paralisia:        "Estou com paralisia",
  Convulsão:        "Tive uma convulsão",
  Formigamento:     "Sinto formigamento / dormência",
  Fraqueza:         "Estou com fraqueza / sem força",
  Desmaio:          "Desmaiei / estou desmaiando",

  // ── Dependência Química ──────────────────────────────────────────────
  Alcoolismo:       "Tenho problema com alcoolismo",
  Álcool:           "Consumi álcool / tenho problema com álcool",
  Droga:            "Uso drogas / tenho dependência",
  Cigarro:          "Fumo cigarro / quero parar de fumar",
  Vício:            "Tenho vício / dependência",

  // ── Órgãos / Anatomia ────────────────────────────────────────────────
  Pescoço:          "Dor no pescoço",
  Garganta:         "Dor na garganta",
  Fígado:           "Dor / problema no fígado",
  Intestino:        "Problema no intestino",
  Útero:            "Dor / problema no útero",
  Ovário:           "Dor / problema no ovário",
  Pâncreas:         "Problema no pâncreas",
  Vesícula:         "Dor na vesícula",
  Próstata:         "Problema na próstata",
  Músculo:          "Dor muscular / lesão muscular",
  Veia:             "Problema na veia",

  // ── Exames / Procedimentos ───────────────────────────────────────────
  Exame_de_Sangue:  "Preciso / fiz exame de sangue",
  Urina_Exame:      "Preciso / fiz exame de urina",
  Endoscopia:       "Preciso fazer endoscopia",
  Fisioterapia:     "Estou fazendo fisioterapia",
  Fonoaudiologia:   "Preciso de fonoaudiologia",
  Tomografia:       "Preciso / fiz tomografia",
  Ressonância:      "Preciso / fiz ressonância magnética",
  Biópsia:          "Preciso / fiz biópsia",
  Internação:       "Preciso ser internado / fui internado",
  UTI:              "Preciso de UTI / estou na UTI",
  Anestesia:        "Vou / fui colocado sob anestesia",
  Hemodiálise:      "Faço hemodiálise",
  Transplante:      "Preciso de transplante / fiz transplante",

  // ── Especialidades médicas ───────────────────────────────────────────
  Cardiologia:      "Preciso de cardiologista",
  Farmacêutico:     "Preciso falar com o farmacêutico",
  Cuidados_Médicos: "Preciso de cuidados médicos",
  Médico_Família:   "Quero falar com meu médico de família",
  Dermatologia:     "Tenho problema de pele / preciso de dermatologista",
  Oftalmologia:     "Tenho problema de visão / preciso de oftalmologista",
  Ginecologia:      "Preciso de ginecologista",
  Ortopedia:        "Preciso de ortopedista",
  Pediatria:        "É para minha criança / preciso de pediatra",
  Urologia:         "Preciso de urologista",

  // ── Doenças específicas ──────────────────────────────────────────────
  Hepatite:         "Tenho hepatite",
  Tuberculose:      "Tenho tuberculose",
  Pneumonia:        "Tenho pneumonia",
  Bronquite:        "Tenho bronquite",
  Artrite:          "Tenho artrite / reumatismo",
  Osteoporose:      "Tenho osteoporose",
  Hipertensão:      "Tenho hipertensão / pressão alta",
  Colesterol:       "Tenho colesterol alto",
  Úlcera:           "Tenho úlcera",
  Trombose:         "Tenho trombose",
  Infarto:          "Tive infarto / dor no peito forte",
  Derrame:          "Tive derrame cerebral",
  Rinite:           "Tenho rinite",
  Dengue:           "Estou com dengue / suspeita de dengue",
  COVID:            "Estou com COVID / suspeita de COVID",
  Gripe:            "Estou com gripe",

  // ── Sintomas adicionais ──────────────────────────────────────────────
  Coceira:          "Estou com coceira",
  Inchaço:          "Estou com inchaço",
  Queimadura:       "Tenho queimadura",
  Cicatriz:         "Tenho cicatriz / ferida",
  Corrimento:       "Tenho corrimento",
  Ardência:         "Sinto ardência",
  Calafrio:         "Estou com calafrio",
  Falta_de_ar:      "Estou com falta de ar",
  Palpitação:       "Sinto palpitação no coração",
  Visão_turva:      "Estou com visão turva / embaçada",
  Dor_de_garganta:  "Estou com dor de garganta",
  Dor_de_ouvido:    "Estou com dor de ouvido",
  Dor_nas_costas:   "Estou com dor nas costas",
  Dor_de_cabeça:    "Estou com dor de cabeça forte",

  // ── Medicamentos ─────────────────────────────────────────────────────
  Antibiótico:      "Estou tomando / preciso de antibiótico",
  Analgésico:       "Preciso de analgésico / remédio para dor",
  Anti_inflamatório:"Preciso de anti-inflamatório",
  Insulina:         "Uso insulina / preciso de insulina",
  Vacina_ext:       "Quero tomar vacina / informação sobre vacina",
  Receita:          "Preciso de receita médica",
  Atestado:         "Preciso de atestado médico",
  Comprimido:       "Estou tomando comprimido",
  Injeção:          "Preciso / tomei injeção",
  Dose:             "Qual é a dose do remédio?",
  Soro:             "Estou / preciso de soro",

  // ── Comunicação hospitalar ───────────────────────────────────────────
  Aqui:             "A dor é aqui / está aqui",
  Forte:            "A dor é forte / muito intensa",
  Fraco:            "Estou fraco / a dor é fraca",
  Muito:            "Muito / demais",
  Sempre:           "Sempre / o tempo todo",
  Às_vezes:         "Às vezes / de vez em quando",
  Nunca:            "Nunca tive isso antes",
  Como:             "Como aconteceu?",
  Melhor:           "Estou melhor / melhorou",
  Pior:             "Estou pior / piorou",
  Urgente:          "É urgente!",
  Alergia_ext:      "Tenho alergia",
  Alérgico:         "Sou alérgico a...",
  Intolerância:     "Tenho intolerância alimentar",
  Barriga_ext:      "Dor na barriga / abdômen",
  Asma_ext:         "Tenho asma / falta de ar",
  Diabetes_ext:     "Sou diabético / glicose alta",

  // ── MALTA medical vocabulary ─────────────────────────────────────────
  Acidente:        "Sofri um acidente",
  Ajuda:           "Preciso de ajuda",
  Alergia:         "Tenho alergia",
  Ambulância:      "Preciso de ambulância",
  Ansiedade:       "Estou ansioso / com ansiedade",
  Asma:            "Tenho asma",
  Barriga:         "Dor na barriga / estômago",
  Beber:           "Quero beber água / líquido",
  Boca:            "Dor na boca / garganta",
  Braço:           "Dor no braço",
  Cabeça:          "Dor de cabeça",
  Cansado:         "Estou cansado / sem energia",
  Cirurgia:        "Preciso de cirurgia / fui operado",
  Comer:           "Quero comer / não consigo comer",
  Consulta:        "Quero agendar consulta",
  Coração:         "Dor no coração / peito",
  Costas:          "Dor nas costas",
  Dente:           "Dor de dente",
  Depressão:       "Estou com depressão",
  Diabetes:        "Sou diabético",
  Dor:             "Estou com dor",
  Dormir:          "Não consigo dormir / estou sonolento",
  Emergência:      "É uma emergência",
  Enfermeiro:      "Preciso de um enfermeiro",
  Enjoo:           "Estou enjoado / com náusea",
  Exame:           "Preciso fazer exame",
  Farmácia:        "Onde fica a farmácia?",
  Febre:           "Estou com febre",
  Frio:            "Estou com frio / calafrios",
  Hospital:        "Preciso ir ao hospital",
  Hospitalização:  "Preciso ser internado",
  Infecção:        "Tenho infecção",
  Medicamento:     "Preciso de medicamento",
  Médico:          "Preciso falar com o médico",
  Nariz:           "Nariz entupido / sangrando",
  Nome:            "Meu nome é...",
  Não:             "Não",
  Obrigado:        "Obrigado",
  Olho:            "Problema nos olhos / visão",
  Osso:            "Dor no osso / possível fratura",
  Ouvido:          "Dor no ouvido / não ouço bem",
  Peito:           "Dor no peito",
  Perna:           "Dor na perna",
  Por_favor:       "Por favor",
  Pressão:         "Pressão alta / baixa",
  Pulmão:          "Problema no pulmão / respiração",
  Queda:           "Sofri uma queda",
  Quente:          "Estou com calor / febre",
  Remédio:         "Preciso de remédio",
  Respirar:        "Dificuldade para respirar",
  Rim:             "Dor no rim",
  Sangramento:     "Estou sangrando",
  Sim:             "Sim",
  Socorro:         "Socorro! Preciso de ajuda urgente",
  Tontura:         "Estou com tontura / vertigem",
  Tosse:           "Estou com tosse",
  Ultrassonografia:"Preciso de ultrassonografia",
  Urgência:        "É urgente",
  Vomitar:         "Estou vomitando / com vômito",
  Água:            "Quero água",
  // ── MINDS-Libras vocabulary ──────────────────────────────────────────
  Acontecer:  "Algo aconteceu comigo",
  Aluno:      "Sou estudante",
  Amarelo:    "Pele/olhos amarelados (icterícia?)",
  America:    "Sou estrangeiro",
  Aproveitar: "Quero aproveitar o tratamento",
  Bala:       "Sinto dor intensa (pontada)",
  Banco:      "Preciso sentar",
  Banheiro:   "Preciso ir ao banheiro urgente",
  Barulho:    "Zumbido no ouvido",
  Cinco:      "Nível de dor: 5",
  Conhecer:   "Quero saber meu diagnóstico",
  Espelho:    "Quero ver meu estado",
  Esquina:    "Dor irradia para outro lugar",
  Filho:      "É para meu filho / familiar",
  Maca:       "Preciso deitar / maca",
  Medo:       "Estou com medo",
  Ruim:       "Estou me sentindo muito mal",
  Sapo:       "Dificuldade para engolir",
  Vacina:     "Informação sobre vacina",
  Vontade:    "Vontade de vomitar / enjoo",
};
